











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import Mappa from "@/components/Mappa.vue";
import CompanyWorker from "@/components/company/CompanyWorker.vue";
import L from "leaflet";
import {workerIsCompatible} from "@/utils";
import EventBus from "@/EventBus";

@Component({
    components: {
        CompanyWorker,
        Mappa
    },
    computed: {
        ...mapGetters({user: 'user', profile: 'profile', isCompany: 'isCompany', workers: 'workers'})
    },
    name: "CompanyWorkers"
})
export default class CompanyWorkers extends Vue {
    @Prop(Object) private readonly filteredAnnouncement!: any | null
    private showing_action_id:string = '';

    private workers?: any[]

    private map_bounds: any | null = null
    private user?: any;
    private profile?: any;
    private show: boolean = false
    private listOffset: number = 0;

    created(){
        EventBus.$on('cw:menu_close', ()=>{this.showAction = ''})
    }

    get showAction(){
        return this.showing_action_id;
    }
    set showAction(val:string){
        this.showing_action_id = val
    }

    get filteredWorkers() {

        return (this.workers as any[]).filter((a) => {
            return this.filterByAnnouncement(a) &&
                a.hasOwnProperty('lat') &&
                a.hasOwnProperty('lng')
                && this.isInBounds(new L.LatLng(a.lat, a.lng));

        }).sort().reduce((prev, curr, idx, arr) => {
            if (!prev.length) {
                prev.push(curr);
            } else if (prev[prev.length - 1].id != curr.id) {
                prev.push(curr);
            }
            return prev
        }, [])

    }

    public invalidateMap() {
        (this.$refs.map as any).invalidate()
    }

    private filterByAnnouncement(worker: any) {
        if (this.filteredAnnouncement != null) {
            return workerIsCompatible(worker, this.filteredAnnouncement, this.profile);
        } else {
            return true
        }

    }

    private isInBounds(latLng: any) {
        if (this.map_bounds) {
            return (this.map_bounds as any).contains(latLng)
        }
        return true
    }

    private limit(mapBounds: any) {
        this.map_bounds = mapBounds;
    }

    private mounted() {
        this.invalidateMap()
    }

    @Watch('filteredAnnouncement')
    private filterChange() {
        this.invalidateMap()

    }

    @Watch('show')
    private showChanged(){
        this.$nextTick(()=>{
            window.setTimeout(()=>{
                (this.$refs.map as any).invalidate(true);
            },200)
        })
    }

    private deactivated(){
        // @ts-ignore
        this.listOffset = document.getElementsByClassName('workers-list')[0].scrollTop;
    }

    private activated(){
        // @ts-ignore
        document.getElementsByClassName('workers-list')[0].scrollTop = this.listOffset;
    }

}

